import React, { useState } from "react";
import userIcon from "../../icons/user.png";
import Logo from "../../images/vdkLogo.png";
import Modal from "../Modal/Modal";

function Header() {
  const [isActiveModal, setIsAtiveModal] = useState(false)
  const [auth, setAuth] = useState(null)
  const [registr, setRegister] = useState(null)
  return (
    <div>
      <nav className="menu-top site-padding-h site-padding-v">
        <div className="menu-top_wrapper">
          <div className="menu-top_item item-logo_wrapper">
            <img src={Logo} alt={Logo} className="item-logo" />
          </div>
          {/* <div className="menu-top_item">Header-item</div>
                <div className="menu-top_item">Header-item</div> */}
        </div>
        <div className="menu-top_wrapper">
          <div className="menu-top_item item-email">
            <a href={`mailto:${process.env.REACT_APP_GLOBAL_EMAIL}`}>
              {process.env.REACT_APP_GLOBAL_EMAIL}
            </a>
          </div>
          <div className="menu-top_item item-phone">
            <a href={`tel:${process.env.REACT_APP_GLOBAL_PHONE_NUMBER}`}>
              {process.env.REACT_APP_GLOBAL_PHONE_NUMBER}
            </a>
          </div>
          <div className="menu-top_item item-phone">
          <a href='#' onClick={()=>{setIsAtiveModal(true); setAuth("auth"); setRegister(null) }}>
            авторизация
            </a>
          </div>
          <div className="menu-top_item item-phone">
            <a href='#' onClick={()=>{setIsAtiveModal(true); setRegister("register");  setAuth(null)}}>
            регистрация
            </a>
          </div>
          <div className="menu-top_item user-group">
            <a className="menu-top_account">
              <img src={userIcon} className="menu-top_account-icon" />
            </a>
            <button className="interface_button-light button-xs">
              расчеты
            </button>
          </div>
        </div>
      </nav>
      {
        isActiveModal ?
        <Modal setIsAtiveModal={setIsAtiveModal} openModal = { auth ? auth : registr }/>
        :
        null
      }
    </div>
  );
}

export default Header;
